import { Component, Input, OnInit } from "@angular/core";
import { AccountBalanceService } from "src/app/services/balance/account-balance.service";
import { ConfigService } from "src/app/services/config/config.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { UtilsService } from "src/app/services/utils/utils.service";
import { Navigator } from 'src/app/components/menu/navigator';
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";
import { EventsService } from "src/app/services/event/event.service";
import { MobileDataService } from "src/app/services/mobile-data/mobile-data.service";
import { DailySpinService } from 'src/app/services/daily-spin/daily-spin.service';
import { take } from 'rxjs/operators';
import { DailySpinModel } from 'src/app/models/daily-spin-model';

@Component({
  selector: 'app-my-free-spin',
  templateUrl: './my-free-spin.component.html',
  styleUrls: ['./my-free-spin.component.scss'],
})

export class MyFreeSpinComponent implements OnInit {
  @Input() hideBack;
  
  public accountBalances: any;
  public dailySlotEnabled: boolean = false;
  public error: any;
  public spins: number = 0;
  public spinNowBtnDisabled: boolean = true;
  public hideBonusFeature = false; // By default feature is enabled. 0 hides the feature.
  public hideBackButtonInNav = false;
  public dailySlotsEmpty: boolean = true;
  public dailySpinData: any = {};
  public spin_promotional_details: string = "";
  public spin_terms_conditions: string = "";

  constructor(
    private readonly config: ConfigService,
    private readonly utilsService: UtilsService,
    private balanceService: AccountBalanceService,
    private gameHubControllerService: GameHubControllerService,
    public navigator: Navigator,
    public events: EventsService,
    public webcontentService: WebcontentService,
    private mobileData: MobileDataService,
    private dailySpinService: DailySpinService,
  ) {
    this.hideBonusFeature = this.config.getConfig().FEATURE_GAME_BONUS_FREE_SPINS ? this.config.getConfig().FEATURE_GAME_BONUS_FREE_SPINS !== '0' : false;
    // this.updateAndRefreshBalance();
    this.spin_promotional_details = this.config.getConfig().SPIN_PROMOTIONAL_DETAILS ? this.config.getConfig().SPIN_PROMOTIONAL_DETAILS: "terms-rs";
    this.spin_terms_conditions = this.config.getConfig().SPIN_TERMS_CONDITIONS ? this.config.getConfig().SPIN_TERMS_CONDITIONS: "aboutus-nj";
    
  }

  ngOnInit(): void {
    if (this.hideBack) {
      this.hideBackButtonInNav = true;
    } else {
      this.hideBackButtonInNav = false;
    }
    this.dailySpinService.initDailyBonus().then(
      result => {
        if(!!result){
          const noSpinCodes = ["NOT_ELIGIBLE"];
          const code = result.payload.code || "";
          if("numSpins" in result.payload && !noSpinCodes.includes(code)){ 
            this.spins= result.payload.numSpins;
          }
          this.spinNowBtnDisabled = this.spins <= 0;
        }
      }
    )
    const appConfig = this.config.getConfig();
    this.dailySlotEnabled = appConfig.SITE_HAS_DAILY_SLOT === '1';
    this.dailySlotsEmpty = !this.dailySlotEnabled && (this.spins <= 0);
    
  }

  private updateAndRefreshBalance() {
    this.balanceService.updateBalance();
    this.balanceService.getBalance().subscribe((response: any) => {
      if (response) {
        this.accountBalances = response;
        this.spins = this.accountBalances?.MFREESPIN?.availableBalance ?? 0;
        this.spinNowBtnDisabled = this.spins <= 0;
      }
    }, (error) => this.error = error);
  }

  protected async onClick() {
    let data = await Promise.resolve(this.dailySpinService.initDailySpinGameUrl());
    if(!!data && data.result == 1){
      return this.gameHubControllerService.launchDailySpin(this.spins);
    }
  }

  protected onOpenExternalURL(url) {
    let obj = {
      action_param: "",
      action_type: "",
      name: "",
    };

    this.mobileData.sendExternalSelection("null");
    this.events.publish("searchbar:keyword:click", obj);
    this.webcontentService.updateExternalLink(url);
    this.events.publish("event:reload:externallinks");
    this.navigator.toWebview(false, url);
    this.navigator.dismiss();
  }

  protected getCDNAsset(stub: string): string {
    return this.utilsService.getCDNAsset(stub);
  }
}